<template>
    <div style="display: inline-block;" class="img-parent">
      <div v-for="(item,index) in imageList" :key="index" style="display: inline-block;margin-right: 5px;" :style="{width:box_width,height:box_height}">
        <p class="closeX" @click="deleteImg(index)">+</p>
        <img :src="item" style="max-width: 100%;"/>
      </div><div v-if="imageList.length < maxCount" @click="updataFile" style="display: inline-block;" :style="{width:box_width,height:box_height}">
        <input ref="file" type="file" style="display: none;" @change="getFiles($event)" accept="image/jpg,image/jpeg"/>
        <span :style="{'line-height':box_height}">+</span>
      </div>
    </div>
</template>

<script>
export default {
  name: 'upload',

  props: [
    'images',
    'maxCount',
    'paramWidth',
    'paramHeight'
  ],

  data () {
    return {
      imageList: [],
      box_width: '100px',
      box_height: '100px'
    }
  },

  // updated() {
  //   console.log('updated');
  // },
  watch: {
    images: {
      deep: false,
      immediate: true,
      handler: function (o, n) {
        this.initImage()
      }
    }
  },

  created () {
    // this.initImage();
  },

  mounted () {
    this.box_height = this.paramHeight || '100px'
    this.box_width = this.paramWidth || '100px'
  },

  methods: {
    initImage: function () {
      var imageList = this.images ? this.images.split(';') : []
      for (var k = 0; k < imageList.length; k++) {
        let str = imageList[k]
        if (str && str.indexOf('http') === 0) {

        } else {
          imageList[k] = this.$request.file_server + imageList[k]
        }
      }
      this.imageList = imageList
    },
    deleteImg: function (index) {
      this.imageList.splice(index, 1)
      this.$emit('clear-image', index)
    },
    updataFile: function () {
      this.$refs.file.dispatchEvent(new MouseEvent('click'))
    },
    getFiles: function (e) {
      var file = e.target.files[0]
      var size = file.size
      if (size < 1024 * 30 || size > 1024 * 1024 * 2) {
        // 小于30K或者大于2M的报错
        alert('图片大小必须大于30K且小于2M')
        return false
      }
      var reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      var that = this
      reader.onload = function () {
        var image_ = new Image()
        image_.src = this.result
        var that_reader = this
        image_.onload = function () {
          // if(this.width < 255 || this.height<300){
          if (this.width < 215 || this.height < 300) {
            // alert('图片宽度不得小于215像素,高度不得小于300像素')
            alert('图片宽度需215像素以上,高度300像素以上')
          } else {
            that.imageList.push(that_reader.result)
            that.$emit('update-image', e)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .img-parent{
    vertical-align: top;
  }
  .img-parent img{
    width: 100%;
    height: 100%;
  }
  .img-parent div .closeX{
    display: inline-block;
    position: absolute;
    width:16px;
    height: 16px;
    line-height: 12px;
    font-size: 10px;
    top:0px;
    right: 0px;
    color: red;
    border: 1px solid red;
    border-radius: 50%;
    background: #fff;
    transform: rotate(45deg);
    cursor: pointer;
  }
  .img-parent div{
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 50px;
    text-align: center;
    border: 1px solid #cccccc;
    display: inline-block;
    vertical-align: top;
  }
  .img-parent span{
    display: inline-block;
    margin-top: -5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/item/upload.vue